import { ProviderDate } from '@bagonboard/ui-kit';
import {
  isDestinationService, isRegulatedService,
} from '@bagonboard/wiseman';


const getUtcTime = timeObj => (Object.keys(timeObj).length
  ? ProviderDate.moment
    .utc(ProviderDate.utcTimezone(`${timeObj.date} ${timeObj.from}`, timeObj.timezone))
    .format()
  : null);

const getAirportDataWithTerminal = airportInfo => ({
  ...airportInfo,
  ...(airportInfo.terminalNumber && { terminal: { number: airportInfo.terminalNumber } }),
});

const getFlightInfoFromFlightData = ({ flightData }) => ({
  ...flightData,
  origin     : getAirportDataWithTerminal(flightData.origin),
  destination: getAirportDataWithTerminal(flightData.destination),
});

export const buildService = (forkmikValues, flightProducts) => {
  const { flightSelected, service } = forkmikValues;
  const { poi, ...address } = service.address;
  const {
    type, numBags, pickup, delivery,
  } = service;

  const { from, to } = isDestinationService(type)
    ? { from: { poi }, to: address }
    : { from: address, to: { poi } };

  const { time: pickupObj } = pickup;
  const { time: deliveryObj } = delivery;
  const pickupTime = getUtcTime(pickupObj);
  const deliveryTime = getUtcTime(deliveryObj);

  const flightInfo = getFlightInfoFromFlightData(flightProducts[flightSelected].flight);

  const vendor = {
    affiliate: 'BOB',
    marketer : flightInfo.marketer,
    ...(isRegulatedService(type) && { operator: flightInfo.operator }),
  };

  return {
    type,
    tier   : 'standard',
    from,
    to,
    bags   : numBags,
    paxs   : [{ numBags }],
    flightInfo,
    ...(pickupTime && { pickupTime, pickupSlot: pickupObj.timeSlot }),
    ...(deliveryTime && { deliveryTime, deliverySlot: deliveryObj.timeSlot }),
    vendor,
    company: vendor.operator || 'BOB',
  };
};
